import React, {useState, useEffect, forwardRef} from 'react';
import PropTypes from 'prop-types';
import {
  SectionWrapper,
  HeaderContent,
  ToggleButton,
  SectionContent,
  SectionHeader,
} from './CollapsibleSection.style';

const CollapsibleSection = forwardRef(({
  id,
  title,
  children,
  defaultCollapsed = false,
  collapsible = true,
  storageKey,
}, ref) => {
  const [collapsed, setCollapsed] = useState(() => {
    if (!collapsible) return false;
    if (storageKey) {
      const saved = localStorage.getItem(`collapsed_${storageKey}`);
      return saved !== null ? saved === 'true' : defaultCollapsed;
    }
    return defaultCollapsed;
  });

  useEffect(() => {
    if (storageKey && collapsible) {
      localStorage.setItem(`collapsed_${storageKey}`, collapsed.toString());
    }
  }, [collapsed, storageKey, collapsible]);

  const toggleCollapsed = () => {
    if (collapsible) {
      setCollapsed(!collapsed);
    }
  };

  return (
    <SectionWrapper id={id} ref={ref}>
      <SectionHeader onClick={toggleCollapsed} collapsible={collapsible}>
        <HeaderContent>{title}</HeaderContent>
        {collapsible && (
          <ToggleButton collapsed={collapsed}>
            <i className="mdi mdi-chevron-down" />
          </ToggleButton>
        )}
      </SectionHeader>
      <SectionContent collapsed={collapsed}>{children}</SectionContent>
    </SectionWrapper>
  );
});

CollapsibleSection.displayName = 'CollapsibleSection';

CollapsibleSection.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  defaultCollapsed: PropTypes.bool,
  collapsible: PropTypes.bool,
  storageKey: PropTypes.string,
};

export default CollapsibleSection;
